import { TableCell, TableRow } from '@mui/material';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React from 'react';

import { ResourceTimelineMessageTypeDto } from '@/api/generated';
import { themeColors } from '@/config/theme/themeColors.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';

interface Props {
  type: ResourceTimelineMessageTypeDto;
}

export const ResourceTimelineMessagesTableRowMissingData: React.FC<Props> = props => {
  const { t } = useTranslationWithPrefix('views.processesDetails.timelineMessages');
  const { type } = props;

  return (
    <>
      <TableRow hover sx={{ border: `1px solid ${themeColors.stroke}` }}>
        <TableCell>
          <Stack spacing={1}>
            <Typography sx={{ color: themeColors.greyDark }} variant="f16Medium">
              {t(`type.${type}`)} - {t('missingData')}
            </Typography>
          </Stack>
        </TableCell>
      </TableRow>
    </>
  );
};
